export const CAROUSEL_ORIGINAL_INDEX = 'addCarouselOriginalIndex';
export const ADD_CAROUSEL_DATA = 'addCarouselData';
